import { Injectable } from '@angular/core';
import { Toaster } from '../objects/ToasterObject'
import { Toast, BodyOutputType, ToasterService } from 'angular2-toaster';

@Injectable({
  providedIn: 'root'
})
export class ToasterMessageService {

  private toasterObject:Toaster[] = [];

  constructor(private toasterService:ToasterService) { }

  pushToaster(toast:Toaster){
    this.toasterObject.push(toast);
  }

  getToaster(){
    return this.toasterObject;
  }

  clearToaster(){
    this.toasterObject = [];
  }

  popToast(title: string, body: string, type: string) {
    var toast: Toast = {
      type: type,
      title: title,
      body: body,
      showCloseButton: true,
      timeout: 10000,
      bodyOutputType: BodyOutputType.TrustedHtml,
      onShowCallback: (toast) => 
      {
        var toaster = new Toaster();
        toaster.id = toast.toastId;
        toaster.timestamp = Date.now();
        toaster.title = toast.title;
        toaster.content = toast.body;
        this.pushToaster(toaster);
      }
    };
    this.toasterService.pop(toast);
  }
}
